// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/bg-branches.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/images/bg-floral-same.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/images/bg-floral.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/images/bg-brick-wall.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/images/bg-red-glass.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/images/bg-doodle.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/images/bg-waves.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/images/bg-black.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/images/mastermind.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Loader css info  */
.loader-info {
    background: currentcolor;
    animation: loader-info 1s ease-in-out infinite;
    animation-delay: 0.4s;
}

.loader-info:after,
.loader-info:before {
    content: '';
    position: absolute;
    width: inherit;
    height: inherit;
    background: inherit;
    animation: inherit;
}

.loader-info:before {
    right: .5em;
    animation-delay: 0.2s;
}

.loader-info:after {
    left: .5em;
    animation-delay: 0.6s;
}

@keyframes loader-info {

    0%,
    100% {
        box-shadow: 0 0 0 currentcolor, 0 0 0 currentcolor;
    }

    50% {
        box-shadow: 0 -.25em 0 currentcolor, 0 .25em 0 currentcolor;
    }
}

.react-calendar {
    width: 100%;
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid #ccc;
    font-family: Arial, Helvetica, sans-serif;
    line-height: 1.125em;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 10px;
    transition: background-color 0.2s;
}

.react-calendar--doubleView {
    width: 100%;
}

.react-calendar--doubleView .react-calendar__viewContainer {
    display: flex;
    margin: -0.5em;
}

.react-calendar--doubleView .react-calendar__viewContainer>* {
    width: 50%;
    margin: 0.5em;
}

.react-calendar,
.react-calendar *,
.react-calendar *:before,
.react-calendar *:after {
    box-sizing: border-box;
}

.react-calendar button {
    margin: 0;
    border: 0;
    outline: none;
}

.react-calendar button:enabled:hover {
    cursor: pointer;
}

.react-calendar__navigation {
    display: flex;
    height: 44px;
    margin-bottom: 1em;
}

.react-calendar__navigation button {
    min-width: 44px;
    background: none;
}

.react-calendar__navigation button:disabled {
    background-color: #f0f0f0;
}

.react-calendar__navigation button:enabled:hover,
.react-calendar__navigation button:enabled:focus {
    background-color: #e6e6e6;
}

.react-calendar__month-view__weekdays {
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 0.8rem;
}

.react-calendar__month-view__weekdays__weekday {
    padding: 0.5em;
}

.react-calendar__month-view__weekNumbers .react-calendar__tile {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75em;
    font-weight: bold;
}

.react-calendar__month-view__days__day--weekend {
    color: #d10000;
}

.react-calendar__month-view__days__day--neighboringMonth {
    color: #757575;
}

.react-calendar__year-view .react-calendar__tile,
.react-calendar__decade-view .react-calendar__tile,
.react-calendar__century-view .react-calendar__tile {
    padding: 2em 0.5em;
}

.react-calendar__tile {
    max-width: 100%;
    padding: 10px 6.6667px;
    background: none;
    text-align: center;
    line-height: 16px;
}

.react-calendar__tile:disabled {
    background-color: #f0f0f0;
}

.react-calendar__tile:enabled:hover,
.react-calendar__tile:enabled:focus {
    background-color: #e6e6e6;
}

.react-calendar__tile--now {
    background: #ffff76;
}

.react-calendar__tile--now:enabled:hover,
.react-calendar__tile--now:enabled:focus {
    background: #ffffa9;
}

.react-calendar__tile--hasActive {
    background: #76baff;
}

.react-calendar__tile--hasActive:enabled:hover,
.react-calendar__tile--hasActive:enabled:focus {
    background: #a9d4ff;
}

.react-calendar__tile--active {
    background: #007bff;
    color: white;
}

.react-calendar__tile--active:enabled:hover,
.react-calendar__tile--active:enabled:focus {
    background: #0056b3;
}

.react-calendar--selectRange .react-calendar__tile--hover {
    background-color: #e6e6e6;
}

.ReactModal__Overlay--after-open {
    z-index: 99999;
}

.flex-order-col .msg-chat-order {
    order: 2;
}

.flex-order-col .msg-avatar-order {
    order: 1;
}




/* TYPING LOADER */

.typing-loader {
    width: 3px;
    height: 3px;
    animation: line 1s linear infinite alternate;
    margin-bottom: -5px;
}

@keyframes line {
    0% {
        background-color: rgba(0, 0, 0, 1);
        box-shadow: 12px 0px 0px 0px rgba(0, 0, 0, 0.2), 24px 0px 0px 0px rgba(0, 0, 0, 0.2);
    }

    25% {
        background-color: rgba(0, 0, 0, 0.4);
        box-shadow: 12px 0px 0px 0px rgba(0, 0, 0, 2), 24px 0px 0px 0px rgba(0, 0, 0, 0.2);
    }

    75% {
        background-color: rgba(0, 0, 0, 0.4);
        box-shadow: 12px 0px 0px 0px rgba(0, 0, 0, 0.2), 24px 0px 0px 0px rgba(0, 0, 0, 2);
    }
}

/* RICH TEXT CSS FOR QUILL INPUT */

.richtext-input .ql-toolbar {
    display: none;
}

.long-richtext .ql-container {
    height: 400px;
}

.comment-richtext .ql-container {
    height: 80px;
}

.activity-richtext b {
    text-transform: capitalize;
    color: rgb(7, 134, 134);
}

.input-richtext .ql-container {
    border: none !important;
}

.msg-type-chat .ql-container {
    height: auto;
}

.msg-type-chat .ql-container .ql-editor {
    padding: 0px 10px 0px 0px !important;
    max-height: 140px;
    overflow: hidden;
    overflow-y: auto;
}

.input-richtext .ql-editor {
    padding: 0px;
    padding-block: 10px;
}

.msg-type-chat .ql-editor.ql-blank::before {
    left: 0px;
}

.msg-type-chat .ql-editor img {
    max-height: 180px;
}

.input-border .ql-container {
    border-top: 0px !important;
}

/* ADDED SCROLL TO QUILL */
.comment-richtext .ql-editor::-webkit-scrollbar,
.long-richtext .ql-editor::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    border-radius: 10px;
}

.comment-richtext .ql-editor::-webkit-scrollbar-thumb {
    border-radius: 10px;
}

.long-richtext .ql-editor::-webkit-scrollbar-thumb {
    border-radius: 10px;
}

.msg-type-chat .ql-container .ql-editor::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    border-radius: 10px;
}

.msg-type-chat .ql-container .ql-editor::-webkit-scrollbar-thumb {
    border-radius: 10px;
}

.scroll-it::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    border-radius: 10px;
}

.scroll-it::-webkit-scrollbar-thumb {
    border-radius: 10px;
}

/* RICHTEXT CSS FOR QUILL TEXT*/

.richtext ul,
ol {
    margin-left: 30px;
}

.richtext ul {
    list-style-type: disc;
}

.richtext ol {
    list-style-type: decimal;
}

.richtext a {
    color: #00f !important;
}

.richtext img {
    max-height: 200px;
}

/* Activity Write A Comment */
.activity-chat-msg .ql-editor {
    padding: 0px 10px 0px 0px !important;
    max-height: 90px;
    overflow: hidden;
    overflow-y: auto;
}

.activity-chat-msg .ql-container {
    height: auto !important;
    border: none !important;
}

.activity-chat-msg .quill.richtext-input {
    padding: 15px;
}

.activity-chat-msg .ql-editor.ql-blank::before {
    left: 0;
    right: 0;
    border: none;
}

/* .frozen{
    -webkit-backdrop-filter: blur(6px);
    backdrop-filter: blur(6px);
    box-shadow: inset 0 0 0 200px rgba(255,255,255,0.09);
    border-top: 2px solid rgba(225, 225, 225, 0.3);
    border-left: 2px solid rgba(225, 225, 225, 0.1);
    border-right: 1px solid rgba(225, 225, 225, 0.2);
} */

/* THEME CSS */
.bg-branches::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    opacity: 0.1;
    z-index: -1;
    background-position: center;
}

.bg-floral-outlined::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    opacity: 0.2;
    z-index: -1;
    background-position: center;
}

.bg-floral-filled::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    opacity: 0.2;
    z-index: -1;
    background-position: center;
}

.bg-brick::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    opacity: 0.4;
    z-index: -1;
    background-position: center;
}

.bg-red-glass::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    opacity: 0.5;
    z-index: -1;
    background-position: center;
}

.bg-doodle::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    opacity: 0.3;
    z-index: -1;
    background-position: center;
}

.bg-waves::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    opacity: 0.3;
    z-index: -1;
    background-position: cover;
    background-position-y: 10px;
}

.bg-black-waves::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    opacity: 0.6;
    z-index: -1;
    background-position: cover;
}

.bg-mastermind {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.richtext-comment b {
    text-transform: capitalize;
    font-weight: 600;
}
.richtext-comment span {
    text-transform: capitalize;
    font-weight: 700;
    color: #6495ed
}

.pagination li{
    list-style-type: none !important;
    margin-left: 10px !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,wBAAwB;IACxB,8CAA8C;IAC9C,qBAAqB;AACzB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,qBAAqB;AACzB;;AAEA;;IAEI;;QAEI,kDAAkD;IACtD;;IAEA;QACI,2DAA2D;IAC/D;AACJ;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,sBAAsB;IACtB,yCAAyC;IACzC,oBAAoB;IACpB,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;;;;IAMI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;IAGI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,QAAQ;AACZ;;;;;AAKA,kBAAkB;;AAElB;IACI,UAAU;IACV,WAAW;IAGX,4CAA4C;IAC5C,mBAAmB;AACvB;;AAoCA;IACI;QACI,kCAAkC;QAClC,oFAAoF;IACxF;;IAEA;QACI,oCAAoC;QACpC,kFAAkF;IACtF;;IAEA;QACI,oCAAoC;QACpC,kFAAkF;IACtF;AACJ;;AAEA,kCAAkC;;AAElC;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,0BAA0B;AAC1B;;IAEI,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,+BAA+B;;AAE/B;;IAEI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA,6BAA6B;AAC7B;IACI,oCAAoC;IACpC,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,QAAQ;IACR,YAAY;AAChB;;AAEA;;;;;;;GAOG;;AAEH,cAAc;AACd;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yDAAwD;IACxD,YAAY;IACZ,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yDAA4D;IAC5D,YAAY;IACZ,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yDAAuD;IACvD,YAAY;IACZ,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yDAA2D;IAC3D,YAAY;IACZ,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yDAAyD;IACzD,YAAY;IACZ,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yDAAsD;IACtD,YAAY;IACZ,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yDAAsD;IACtD,YAAY;IACZ,WAAW;IACX,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yDAAqD;IACrD,YAAY;IACZ,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,yDAAuD;AAC3D;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;AACA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB;AACJ;;AAEA;IACI,gCAAgC;IAChC,4BAA4B;AAChC","sourcesContent":["/* Loader css info  */\n.loader-info {\n    background: currentcolor;\n    animation: loader-info 1s ease-in-out infinite;\n    animation-delay: 0.4s;\n}\n\n.loader-info:after,\n.loader-info:before {\n    content: '';\n    position: absolute;\n    width: inherit;\n    height: inherit;\n    background: inherit;\n    animation: inherit;\n}\n\n.loader-info:before {\n    right: .5em;\n    animation-delay: 0.2s;\n}\n\n.loader-info:after {\n    left: .5em;\n    animation-delay: 0.6s;\n}\n\n@keyframes loader-info {\n\n    0%,\n    100% {\n        box-shadow: 0 0 0 currentcolor, 0 0 0 currentcolor;\n    }\n\n    50% {\n        box-shadow: 0 -.25em 0 currentcolor, 0 .25em 0 currentcolor;\n    }\n}\n\n.react-calendar {\n    width: 100%;\n    background: rgba(255, 255, 255, 0.9);\n    border: 1px solid #ccc;\n    font-family: Arial, Helvetica, sans-serif;\n    line-height: 1.125em;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    padding: 10px;\n    transition: background-color 0.2s;\n}\n\n.react-calendar--doubleView {\n    width: 100%;\n}\n\n.react-calendar--doubleView .react-calendar__viewContainer {\n    display: flex;\n    margin: -0.5em;\n}\n\n.react-calendar--doubleView .react-calendar__viewContainer>* {\n    width: 50%;\n    margin: 0.5em;\n}\n\n.react-calendar,\n.react-calendar *,\n.react-calendar *:before,\n.react-calendar *:after {\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n}\n\n.react-calendar button {\n    margin: 0;\n    border: 0;\n    outline: none;\n}\n\n.react-calendar button:enabled:hover {\n    cursor: pointer;\n}\n\n.react-calendar__navigation {\n    display: flex;\n    height: 44px;\n    margin-bottom: 1em;\n}\n\n.react-calendar__navigation button {\n    min-width: 44px;\n    background: none;\n}\n\n.react-calendar__navigation button:disabled {\n    background-color: #f0f0f0;\n}\n\n.react-calendar__navigation button:enabled:hover,\n.react-calendar__navigation button:enabled:focus {\n    background-color: #e6e6e6;\n}\n\n.react-calendar__month-view__weekdays {\n    text-align: center;\n    text-transform: uppercase;\n    font-weight: bold;\n    font-size: 0.8rem;\n}\n\n.react-calendar__month-view__weekdays__weekday {\n    padding: 0.5em;\n}\n\n.react-calendar__month-view__weekNumbers .react-calendar__tile {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.75em;\n    font-weight: bold;\n}\n\n.react-calendar__month-view__days__day--weekend {\n    color: #d10000;\n}\n\n.react-calendar__month-view__days__day--neighboringMonth {\n    color: #757575;\n}\n\n.react-calendar__year-view .react-calendar__tile,\n.react-calendar__decade-view .react-calendar__tile,\n.react-calendar__century-view .react-calendar__tile {\n    padding: 2em 0.5em;\n}\n\n.react-calendar__tile {\n    max-width: 100%;\n    padding: 10px 6.6667px;\n    background: none;\n    text-align: center;\n    line-height: 16px;\n}\n\n.react-calendar__tile:disabled {\n    background-color: #f0f0f0;\n}\n\n.react-calendar__tile:enabled:hover,\n.react-calendar__tile:enabled:focus {\n    background-color: #e6e6e6;\n}\n\n.react-calendar__tile--now {\n    background: #ffff76;\n}\n\n.react-calendar__tile--now:enabled:hover,\n.react-calendar__tile--now:enabled:focus {\n    background: #ffffa9;\n}\n\n.react-calendar__tile--hasActive {\n    background: #76baff;\n}\n\n.react-calendar__tile--hasActive:enabled:hover,\n.react-calendar__tile--hasActive:enabled:focus {\n    background: #a9d4ff;\n}\n\n.react-calendar__tile--active {\n    background: #007bff;\n    color: white;\n}\n\n.react-calendar__tile--active:enabled:hover,\n.react-calendar__tile--active:enabled:focus {\n    background: #0056b3;\n}\n\n.react-calendar--selectRange .react-calendar__tile--hover {\n    background-color: #e6e6e6;\n}\n\n.ReactModal__Overlay--after-open {\n    z-index: 99999;\n}\n\n.flex-order-col .msg-chat-order {\n    order: 2;\n}\n\n.flex-order-col .msg-avatar-order {\n    order: 1;\n}\n\n\n\n\n/* TYPING LOADER */\n\n.typing-loader {\n    width: 3px;\n    height: 3px;\n    -webkit-animation: line 1s linear infinite alternate;\n    -moz-animation: line 1s linear infinite alternate;\n    animation: line 1s linear infinite alternate;\n    margin-bottom: -5px;\n}\n\n@-webkit-keyframes line {\n    0% {\n        background-color: rgba(0, 0, 0, 1);\n        box-shadow: 12px 0px 0px 0px rgba(0, 0, 0, 0.2), 24px 0px 0px 0px rgba(0, 0, 0, 0.2);\n    }\n\n    25% {\n        background-color: rgba(0, 0, 0, 0.4);\n        box-shadow: 12px 0px 0px 0px rgba(0, 0, 0, 2), 24px 0px 0px 0px rgba(0, 0, 0, 0.2);\n    }\n\n    75% {\n        background-color: rgba(0, 0, 0, 0.4);\n        box-shadow: 12px 0px 0px 0px rgba(0, 0, 0, 0.2), 24px 0px 0px 0px rgba(0, 0, 0, 2);\n    }\n}\n\n@-moz-keyframes line {\n    0% {\n        background-color: rgba(0, 0, 0, 1);\n        box-shadow: 12px 0px 0px 0px rgba(0, 0, 0, 0.2), 24px 0px 0px 0px rgba(0, 0, 0, 0.2);\n    }\n\n    25% {\n        background-color: rgba(0, 0, 0, 0.4);\n        box-shadow: 12px 0px 0px 0px rgba(0, 0, 0, 2), 24px 0px 0px 0px rgba(0, 0, 0, 0.2);\n    }\n\n    75% {\n        background-color: rgba(0, 0, 0, 0.4);\n        box-shadow: 12px 0px 0px 0px rgba(0, 0, 0, 0.2), 24px 0px 0px 0px rgba(0, 0, 0, 2);\n    }\n}\n\n@keyframes line {\n    0% {\n        background-color: rgba(0, 0, 0, 1);\n        box-shadow: 12px 0px 0px 0px rgba(0, 0, 0, 0.2), 24px 0px 0px 0px rgba(0, 0, 0, 0.2);\n    }\n\n    25% {\n        background-color: rgba(0, 0, 0, 0.4);\n        box-shadow: 12px 0px 0px 0px rgba(0, 0, 0, 2), 24px 0px 0px 0px rgba(0, 0, 0, 0.2);\n    }\n\n    75% {\n        background-color: rgba(0, 0, 0, 0.4);\n        box-shadow: 12px 0px 0px 0px rgba(0, 0, 0, 0.2), 24px 0px 0px 0px rgba(0, 0, 0, 2);\n    }\n}\n\n/* RICH TEXT CSS FOR QUILL INPUT */\n\n.richtext-input .ql-toolbar {\n    display: none;\n}\n\n.long-richtext .ql-container {\n    height: 400px;\n}\n\n.comment-richtext .ql-container {\n    height: 80px;\n}\n\n.activity-richtext b {\n    text-transform: capitalize;\n    color: rgb(7, 134, 134);\n}\n\n.input-richtext .ql-container {\n    border: none !important;\n}\n\n.msg-type-chat .ql-container {\n    height: auto;\n}\n\n.msg-type-chat .ql-container .ql-editor {\n    padding: 0px 10px 0px 0px !important;\n    max-height: 140px;\n    overflow: hidden;\n    overflow-y: auto;\n}\n\n.input-richtext .ql-editor {\n    padding: 0px;\n    padding-block: 10px;\n}\n\n.msg-type-chat .ql-editor.ql-blank::before {\n    left: 0px;\n}\n\n.msg-type-chat .ql-editor img {\n    max-height: 180px;\n}\n\n.input-border .ql-container {\n    border-top: 0px !important;\n}\n\n/* ADDED SCROLL TO QUILL */\n.comment-richtext .ql-editor::-webkit-scrollbar,\n.long-richtext .ql-editor::-webkit-scrollbar {\n    width: 4px;\n    height: 4px;\n    border-radius: 10px;\n}\n\n.comment-richtext .ql-editor::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n}\n\n.long-richtext .ql-editor::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n}\n\n.msg-type-chat .ql-container .ql-editor::-webkit-scrollbar {\n    width: 4px;\n    height: 4px;\n    border-radius: 10px;\n}\n\n.msg-type-chat .ql-container .ql-editor::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n}\n\n.scroll-it::-webkit-scrollbar {\n    width: 4px;\n    height: 4px;\n    border-radius: 10px;\n}\n\n.scroll-it::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n}\n\n/* RICHTEXT CSS FOR QUILL TEXT*/\n\n.richtext ul,\nol {\n    margin-left: 30px;\n}\n\n.richtext ul {\n    list-style-type: disc;\n}\n\n.richtext ol {\n    list-style-type: decimal;\n}\n\n.richtext a {\n    color: #00f !important;\n}\n\n.richtext img {\n    max-height: 200px;\n}\n\n/* Activity Write A Comment */\n.activity-chat-msg .ql-editor {\n    padding: 0px 10px 0px 0px !important;\n    max-height: 90px;\n    overflow: hidden;\n    overflow-y: auto;\n}\n\n.activity-chat-msg .ql-container {\n    height: auto !important;\n    border: none !important;\n}\n\n.activity-chat-msg .quill.richtext-input {\n    padding: 15px;\n}\n\n.activity-chat-msg .ql-editor.ql-blank::before {\n    left: 0;\n    right: 0;\n    border: none;\n}\n\n/* .frozen{\n    -webkit-backdrop-filter: blur(6px);\n    backdrop-filter: blur(6px);\n    box-shadow: inset 0 0 0 200px rgba(255,255,255,0.09);\n    border-top: 2px solid rgba(225, 225, 225, 0.3);\n    border-left: 2px solid rgba(225, 225, 225, 0.1);\n    border-right: 1px solid rgba(225, 225, 225, 0.2);\n} */\n\n/* THEME CSS */\n.bg-branches::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: url(\"./assets/images/bg-branches.png\");\n    opacity: 0.1;\n    z-index: -1;\n    background-position: center;\n}\n\n.bg-floral-outlined::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: url(\"./assets/images/bg-floral-same.webp\");\n    opacity: 0.2;\n    z-index: -1;\n    background-position: center;\n}\n\n.bg-floral-filled::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: url(\"./assets/images/bg-floral.webp\");\n    opacity: 0.2;\n    z-index: -1;\n    background-position: center;\n}\n\n.bg-brick::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: url(\"./assets/images/bg-brick-wall.webp\");\n    opacity: 0.4;\n    z-index: -1;\n    background-position: center;\n}\n\n.bg-red-glass::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: url(\"./assets/images/bg-red-glass.jpg\");\n    opacity: 0.5;\n    z-index: -1;\n    background-position: center;\n}\n\n.bg-doodle::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: url(\"./assets/images/bg-doodle.jpg\");\n    opacity: 0.3;\n    z-index: -1;\n    background-position: center;\n}\n\n.bg-waves::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: url(\"./assets/images/bg-waves.webp\");\n    opacity: 0.3;\n    z-index: -1;\n    background-position: cover;\n    background-position-y: 10px;\n}\n\n.bg-black-waves::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: url(\"./assets/images/bg-black.png\");\n    opacity: 0.6;\n    z-index: -1;\n    background-position: cover;\n}\n\n.bg-mastermind {\n    background-image: url(\"./assets/images/mastermind.jpg\");\n}\n\n.richtext-comment b {\n    text-transform: capitalize;\n    font-weight: 600;\n}\n.richtext-comment span {\n    text-transform: capitalize;\n    font-weight: 700;\n    color: #6495ed\n}\n\n.pagination li{\n    list-style-type: none !important;\n    margin-left: 10px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
